import { z } from 'zod';

export const AddressSchema = z.object({
    firstname: z
        .string()
        .min(2, { message: 'First name is required.' })
        .max(16, { message: 'First name must be less than 17 characters.' })
        .regex(/^[ a-zA-Z._'-]+$/, 'Numbers and special characters are not allowed.'),
    lastname: z
        .string()
        .min(2, { message: 'Last name is required.' })
        .max(16, { message: 'Last name must be less than 17 characters.' })
        .regex(/^[ a-zA-Z._'-]+$/, 'Numbers and special characters are not allowed.'),
    dayphone: z
        .string()
        .min(2, { message: 'Please enter a 10 digit phone number, including area code.' })
        .min(14, { message: 'Please enter a 10 digit phone number, including area code.' }),
    address: z.string().min(2, { message: 'Address is required.' }).max(30),
    address2: z.string().max(30),
    province: z
        .enum(['a', 'AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'])
        // .string()
        .default('ON')
        .refine((value) => value !== 'a', {
            message: 'Province is required.',
        }),
    postalcode: z.string().min(7, { message: 'Please enter a valid postal code.' }),
    city: z.string().min(2, { message: 'City is required.' }).max(30),
    // defaultShipping: z.boolean(),
    defaultBilling: z.union([z.literal(true), z.literal(false), z.literal('indeterminate')]),
    defaultShipping: z.union([z.literal(true), z.literal(false), z.literal('indeterminate')]),
});

export enum province {
    A = 'a',
    B = 'AB',
    C = 'BC',
    D = 'MB',
    E = 'NB',
    F = 'NL',
    G = 'NT',
    H = 'NS',
    I = 'NU',
    J = 'ON',
    K = 'PE',
    L = 'QC',
    M = 'SK',
    N = 'YT',
}
